import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react'
import { Table, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label } from "reactstrap"
import { DetalleActividadHorasExtras, PutActividadHoraExtra } from '../TypesParametrosHorasExtras';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';

import { ReactComponent as EditarSVG } from "../../../../../assets/icons/editar.svg";
import { SelectCombo } from 'components/Types/GeneralTypes';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ActualizarActividadHoraExtra } from '../FunctionsParametrosHE';


import { showAlert } from './ActividadesHorasExtras';
import ReactSwitch from 'react-switch';
import SelectItem2 from 'components/Varios/SelectNew';


type PropsTableServidoresPlanHE = {
    actividadesHorasExtras: DetalleActividadHorasExtras[],
    opcionesEstado: SelectCombo[]
    cargarActividades: () => Promise<void>
    opcionesGrupo: SelectCombo[],
    grupoFiltro:string,
    regimenFiltro:string
}

export default function TableActividadesHorasExtras(props: PropsTableServidoresPlanHE) {

    const { actividadesHorasExtras } = props;





    const [actualizando, setactualizando] = useState<boolean>(false)
    const [loading, setloading] = useState<boolean>(false)
    const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
    const [observations, setObservations] = useState<Record<number, string[]>>({});

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    const [filterStatus, setFilterStatus] = useState('A'); // '' will show all rows by default



    const [actividadEditando, setactividadEditando] = useState<DetalleActividadHorasExtras | undefined>(undefined)
    const [actividadHabilitando, setactividadHabilitando] = useState<DetalleActividadHorasExtras | undefined>(undefined)
    const [estadoActividad, setestadoActividad] = useState<string | undefined>(undefined)
    //States Modal Actualizando
    const [textoActividad, settextoActividad] = useState<string>("")
    const [grupoSeleccionadoActualizar, setgrupoSeleccionadoActualizar] = useState<SelectCombo | null>(null)

    
    const filteredServidores = actividadesHorasExtras.filter(actv =>
        (actv.actividad.toLowerCase().includes(searchTerm.toLowerCase()) ||
            actv.estadoParse.toLowerCase().includes(searchTerm.toLowerCase()) ||
            actv.usuario.toLowerCase().includes(searchTerm.toLowerCase()) ||
            actv.regimenSiglas.toLowerCase().includes(searchTerm.toLowerCase())
        ) &&
        actv.estado.trim().toLowerCase() === filterStatus.trim().toLocaleLowerCase()
        && (props.grupoFiltro !== "" ? actv.grupo.trim().toLowerCase() === props.grupoFiltro.trim().toLowerCase() : true)
        && (props.regimenFiltro !== "" ? actv.regimenSiglas.trim().toLowerCase() === props.regimenFiltro.trim().toLowerCase() : true)


    );

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = filteredServidores.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredServidores.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));


    useEffect(() => {
        // Cargar los valores del localStorage cuando se monta el componente
        const savedRowsPerPage = localStorage.getItem('rowsPerPageActividades');
        const savedSortColumn = localStorage.getItem('sortColumnActividades');
        const savedSortDirection = localStorage.getItem('sortDirectionActividades');

        if (savedRowsPerPage) {
            setRowsPerPage(parseInt(savedRowsPerPage, 10));
        }
        if (savedSortColumn) {
            setSortColumn(savedSortColumn);
        }
        if (savedSortDirection) {
            setSortDirection(savedSortDirection);
        }
    }, []);

    const handleSort = (column: string) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        const newSortDirection = isAsc ? 'desc' : 'asc';

        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render

        localStorage.setItem('sortColumnActividades', column);
        localStorage.setItem('sortDirectionActividades', newSortDirection);
    };


    const applySorting = (data: DetalleActividadHorasExtras[]) => {
        if (!sortColumn) return data;

        if (sortColumn !== null && data !== null) {
            const sortedData = [...data].sort((a, b) => {
                const valA = a[sortColumn];
                const valB = b[sortColumn];
                return (valA < valB ? -1 : 1) * (sortDirection === 'asc' ? 1 : -1);
            });
            return sortedData;
        }

        return data;

    };

    const sortedActividades = applySorting(filteredServidores);
    currentRows = sortedActividades.slice(indexOfFirstRow, indexOfLastRow);



    const handleObservationChange = (idServ: number, index: number, value: string) => {
        const updatedObservations = { ...observations };
        updatedObservations[idServ][index] = value;
        setObservations(updatedObservations);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(selectedRowsPerPage);
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
        localStorage.setItem('rowsPerPageActividades', selectedRowsPerPage.toString());
    };


    const handleChangeSelect = (setter: Dispatch<SetStateAction<string>>) => (value: string) => {
        setter((value));
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const ActualizarActividad = useCallback(
        async (actividad: DetalleActividadHorasExtras | undefined) => {

            if (actividad === undefined) {
                return -1;
            }

            setactualizando(true)


            var copiaActividad: PutActividadHoraExtra = {
                actividad: actividad.actividad,
                estado: actividad.estado,
                idActividad: actividad.idActividad,
                idGrupo: actividad.idGrupo
            }

            copiaActividad.actividad = textoActividad;
            if (grupoSeleccionadoActualizar) {
                copiaActividad.idGrupo = +grupoSeleccionadoActualizar.value
            }


            const respuesta = await ActualizarActividadHoraExtra(copiaActividad)
            if (respuesta.status === 200) {
                showAlert("Se ha actualizado la actividad", true)
                setactualizando(false)
                props.cargarActividades()
                return 1

            }
            else {
                showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
                setactualizando(false)
                return -1
            }
        },
        [textoActividad, estadoActividad, grupoSeleccionadoActualizar],
    )

    const HabilitarActividad = useCallback(
        async () => {
            if (actividadHabilitando && estadoActividad) {
                setactualizando(true)
                const actividadActualizar: PutActividadHoraExtra = {
                    actividad: actividadHabilitando.actividad,
                    estado: estadoActividad,
                    idActividad: actividadHabilitando.idActividad,
                    idGrupo: actividadHabilitando.idGrupo
                }

                const respuesta = await ActualizarActividadHoraExtra(actividadActualizar)
                if (respuesta.status === 200) {
                    const mensajeEstado = estadoActividad === "A" ? "habilitado" : "inhabilitado";
                    showAlert(`Se ha ${mensajeEstado} la actividad`, true)
                    setactualizando(false)
                    props.cargarActividades()
                    return 1

                }
                else {
                    showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
                    setactualizando(false)
                    return -1
                }
            }
            else {
                showAlert("Debe seleccionar una actividad para activar/inactivar", false);

            }

            return -1
        }, [actividadHabilitando, estadoActividad])



    useEffect(() => {
        if (actividadEditando !== undefined) {
            settextoActividad(actividadEditando.actividad);
            setestadoActividad(actividadEditando.estado)
            setgrupoSeleccionadoActualizar({ label: actividadEditando.grupo, value: actividadEditando.idGrupo.toString() })
        }
    }, [actividadEditando])


    const stylesInput: React.CSSProperties = {
        textAlign: 'center',
        width: '100%',
        fontFamily: "Roboto",
        fontSize: "1.40em"
    }

    const contenidoModalActualizarActividad = useMemo(
        () => {
            if (actividadEditando) {
                return (
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelParametrosHE"}> Regimen</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input className="font-modal-he2" type="text" value={actividadEditando.regimenSiglas} readOnly>
                                        </Input>
                                    </Col>
                                    <Col xl={12} className="mt-2">
                                        <span className={"labelParametrosHE"}> Grupo</span>

                                    </Col>
                                    {
                                        grupoSeleccionadoActualizar &&
                                        <Col xl={12}>
                                            <SelectItem2
                                                options={props.opcionesGrupo}
                                                placeholder=""
                                                name="grupoactividad"
                                                id="grupoactividad"
                                                icon="fa-caret-down"
                                                value={grupoSeleccionadoActualizar}
                                                onChange={(value, name, tipo, label) => { setgrupoSeleccionadoActualizar({ label: label, value: value }) }}
                                                maxMenuHeight={81}
                                                stylesInput={stylesInput}
                                            />
                                        </Col>
                                    }

                                    <Col xl={12} className="mt-2">
                                        <span className={"labelParametrosHE"}> Actividad</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input className="font-modal-he2" type="text" value={textoActividad} onChange={(e) => {

                                            var texto = e.target.value;
                                            if (texto) {
                                                texto = texto.toUpperCase()
                                            }
                                            settextoActividad(texto)
                                        }}>
                                        </Input>
                                    </Col>

                                </Row>
                            </Col>

                        </Row>

                    </React.Fragment>

                )
            }
            else if (actividadHabilitando && estadoActividad) {


                const mensajeEstado = estadoActividad === "A" ? "habilitar" : "inhabilitar";

                return (
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <div className="font-modal-he2">
                                            ¿Desea <span><strong>{mensajeEstado}</strong> la siguiente actividad?</span>
                                        </div>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xl={12}>
                                        <div className="mt-3 font-modal-he">{actividadHabilitando.actividad}</div>
                                    </Col>

                                </Row>
                            </Col>

                        </Row>

                    </React.Fragment>

                )
            }
            else {
                return (
                    <div> No se ha seleccionado actividad para editar </div>
                )
            }
        },
        [actividadEditando, actividadHabilitando, textoActividad, estadoActividad, props.opcionesGrupo, grupoSeleccionadoActualizar],
    )

    function OnPressSwitchActividad(actividadHabilitando: DetalleActividadHorasExtras) {
        setactividadHabilitando(actividadHabilitando)
        const nuevoEstado: string = actividadHabilitando.estado === "A" ? "I" : "A"
        setestadoActividad(nuevoEstado)
    }



    return (
        <React.Fragment>
            <Row className="mb-1">
                <Col md="3" className="d-flex flex-column align-self-end justify-content-start">
                    <Label for="select" className="mb-1 labelParametrosHE">Estado</Label>
                    <Input
                        type="select"
                        placeholder="Estado"
                        value={filterStatus}
                        onChange={handleFilterStatusChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    >
                        {
                            props.opcionesEstado.map((v, i) => {
                                return (
                                    <option key={"opcionesEstadoAHE" + i} value={v.value.trim()}>{v.label}</option>
                                )
                            })
                        }
                    </Input>
                </Col>
            </Row>
            <Row className="mt-1 mb-1" >
                <Col md="4" className="d-flex flex-column align-self-end justify-content-start">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2" // Ajusta el tamaño del select
                            style={{ width: 'auto' }} // Asegura que el select no tome más espacio del necesario
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>

                <Col md={{ size: 3, offset: 5 }} className="d-flex flex-column align-self-end">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>

            </Row>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_planificacion_he">
                    <tr className="borde_cabeceras_he">
                        <th colSpan={1} onClick={() => handleSort('actividad')}>Actividad</th>
                        <th colSpan={1} onClick={() => handleSort('regimenSiglas')}>Régimen</th>
                        <th colSpan={1} onClick={() => handleSort('grupo')}>Grupo</th>
                        <th colSpan={1} onClick={() => handleSort('estadoParse')}>Estado</th>
                        <th colSpan={1} onClick={() => handleSort('siglasregimenlaboral')}>Usuario</th>
                        <th colSpan={1} onClick={() => handleSort('rnu')}>F. último cambio</th>

                        <th colSpan={1}>Acciones</th>
                    </tr>
                </thead>
                {currentRows.map((serv, idServ) => {
                    return (
                        <React.Fragment key={idServ}>
                            <tbody>
                                <tr className='rows_tabla_planificacion_he'>
                                    <td className=''>
                                        <div style={{ textAlign: "left", paddingLeft: "10px" }}>
                                            {serv.actividad}
                                        </div>

                                    </td>
                                    <td className='centrado'>{serv.regimenSiglas}</td>
                                    <td className='centrado'>{serv.grupo}</td>
                                    <td className='centrado'>{serv.estadoParse}</td>
                                    <td className='centrado'>{serv.usuario}</td>

                                    <td className='centrado'>{ObtenerFechaFromIsoFormat(serv.ultimoCambio.toString())}</td>

                                    <td>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>

                                            <EditarSVG
                                                className="iconEditarActividadHE"
                                                onClick={() => setactividadEditando(serv)}
                                            />

                                            <ReactSwitch
                                                onChange={() => OnPressSwitchActividad(serv)}
                                                checked={serv.estado === "A"}
                                                offColor="#FFFFFF"
                                                onColor="#243165"
                                                offHandleColor="#243165"
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                height={20}
                                                width={30}
                                                className={"custom-switch-actividadHE"}
                                            />


                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </React.Fragment>
                    )



                })}
            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>


            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={actividadEditando !== undefined}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Actualizar'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='btnConfirmarHabActHE'
                classNameBotonCerrarModal2='btnCancelarHabActHE'
                onClose={() => setactividadEditando(undefined)}
                asyncOnClick={() => ActualizarActividad(actividadEditando)}
                contentModal={contenidoModalActualizarActividad}
                tituloModal='Editar actividad'
            />


            <ModalConfirmacion
                idModal="ModalHabilitarActividadHE"
                show={actividadHabilitando !== undefined && estadoActividad !== undefined}
                size='md'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Confirmar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => { setactividadHabilitando(undefined); setestadoActividad(undefined) }}
                asyncOnClick={() => HabilitarActividad()}
                contentModal={contenidoModalActualizarActividad}
                classNameContentModal=''
                tituloModal=''
                noModalHeader={true}
                classNameBotonAccion='btnConfirmarHabActHE'
                classNameBotonCerrarModal2='btnCancelarHabActHE'
            />

        </React.Fragment>

    )
}
